import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

/**
 * COMPONENTE: OverlayQuizz OVERLAY (DESIGN / CHILD VISUAL)
 * ------------------------------------------------------------------
 * Este componente maneja la visualización e interactividad del Overlay.
 * Renderiza dos códigos QR con coordenadas de píxeles exactas.
 * ------------------------------------------------------------------
 */
export function OverlayQuizz({ flowState, offsetY, bannerMode, winnerName, showConfetti }) {
    
    if (flowState === 'idle') return null;

    const qrValue = `${window.location.origin}/quizz-b9?s=obs`;

    return (
        <div className="overlayquizz" style={{ bottom: `${offsetY}px` }}>
            {/* GPU-Accelerated CSS Confetti */}
            {showConfetti && bannerMode === 'winner' && (
                <div className="overlayquizz-confetti">
                    {[...Array(40)].map((_, i) => (
                        <div key={i} className="overlayquizz-confetti__piece" />
                    ))}
                </div>
            )}

            <div className={`overlayquizz__banner overlayquizz__banner--${flowState}`}>
                {bannerMode === 'invitation' ? (
                    <div className='overlayquizz__banner--v2'>
                        {/* 1536px and 1920px images */}
                        <img src='/img/overlays/rubaquiz/cintillo-ruba-1536-x-180-px.png' className='overlayquizz__banner--v2__Image--Md' alt="Banner Barrio9" />
                        <img src='/img/overlays/rubaquiz/cintillo-ruba-1920-x-180-px.png' className='overlayquizz__banner--v2__Image--Lg' alt="Banner Barrio9 Lg" />
                        
                        {/* Left QR Code */}
                        <div className='overlayquizz__banner--v2__QR-Overlay overlayquizz__banner--v2__QR-Overlay--left'>
                            <QRCodeSVG 
                                value={qrValue} 
                                size={256}
                                style={{ width: '92%', height: '92%', display: 'block' }}
                                bgColor={"#d9d9d9"} 
                                fgColor={"#000000"} 
                                level={"H"} 
                                imageSettings={{
                                    src: "/img/overlays/rubaquiz/interaktia-transparent.png",
                                    x: undefined,
                                    y: undefined,
                                    height: 52,
                                    width: 52,
                                    excavate: true, 
                                }}
                            />
                        </div>

                        {/* Right QR Code */}
                        <div className='overlayquizz__banner--v2__QR-Overlay overlayquizz__banner--v2__QR-Overlay--right'>
                            <QRCodeSVG 
                                value={qrValue} 
                                size={256}
                                style={{ width: '92%', height: '92%', display: 'block' }}
                                bgColor={"#d9d9d9"} 
                                fgColor={"#000000"} 
                                level={"H"} 
                                imageSettings={{
                                    src: "/img/overlays/rubaquiz/interaktia-transparent.png",
                                    x: undefined,
                                    y: undefined,
                                    height: 52,
                                    width: 52,
                                    excavate: true, 
                                }}
                            />
                        </div>
                    </div>
                ) : (
                    <div className='overlayquizz__banner__winner' style={{ backgroundColor: '#23214a' }}>
                        {/* Left Side Logo */}
                        <div className="overlayquizz__logo overlayquizz__logo--left">
                            <img src="/img/overlays/rubaquiz/interaktia-barrio9.png" alt="Interaktia ADSL Logo Left" style={{ height: '180px' }} />
                        </div>

                        {/* Center Winner Name */}
                        <div className="overlayquizz__content">
                            <p className="overlayquizz__subtitle animate-pulse mb-1 text-uppercase" style={{ color: '#ecaa1f' }}>
                                🎉 ¡Tenemos ganador(a) de la encuesta Barrio 9! 🎉
                            </p>
                            <h2 className="overlayquizz__title text-uppercase" style={{ color: '#ffffff' }}>
                                {winnerName || 'Y el ganador es...'}
                            </h2>
                            {/* <p className="overlayquizz__credits">Powered by Interaktia</p> */}
                        </div>

                        {/* Right Side Promo Image */}
                        <div className="overlayquizz__logo overlayquizz__logo--right">
                            <img src="/img/overlays/rubaquiz/interaktia-barrio9.png" alt="Interaktia ADSL Logo Left" style={{ height: '180px' }} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default OverlayQuizz;
